import React from 'react';
import { Dialog, DialogTitle, DialogContent, Button, Typography, Stack, Box } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import TranslateIcon from '@mui/icons-material/Translate';

/**
 * Simple preference dialog that lets the user select between PTE and IELTS.
 * Props:
 *   open    : boolean – controls visibility
 *   onSelect: function(examType) – called with 'pte' or 'ielts'
 */
const ExamPreferenceModal = ({ open, onSelect }) => {
  return (
    <Dialog open={open} disableEscapeKeyDown maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3, p: 2 } }}>
      <DialogTitle sx={{ textAlign: 'center', mb:2 }}>Select Exam Preference</DialogTitle>
     

      <Box sx={{ pb: 3 }}>
        <Stack direction="row" justifyContent="center" spacing={3}>
          <Button
            variant="contained"
            size="large"
            onClick={() => onSelect('pte')}
            startIcon={<SchoolIcon />}
            sx={{ backgroundColor: '#1976d2', '&:hover': { backgroundColor: '#1565c0' }, textTransform: 'none', minWidth: 120 }}
          >
            PTE
          </Button>
          <Button
            variant="contained"
            size="large"
            onClick={() => onSelect('ielts')}
            startIcon={<TranslateIcon />}
            sx={{ backgroundColor: '#8e24aa', '&:hover': { backgroundColor: '#6a1b9a' }, textTransform: 'none', minWidth: 120 }}
          >
            IELTS
          </Button>
        </Stack>
      </Box>
    </Dialog>
  );
};

export default ExamPreferenceModal;
